import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import React, { useState, useEffect, useMemo, useRef } from "react";
import { useParams } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import Button from "react-bootstrap/Button";
import Accordion from "react-bootstrap/Accordion";
import { Formik } from "formik";
import "react-datepicker/dist/react-datepicker.css";
import ColumnResizer from "react-table-column-resizer";
import { nanoid } from "nanoid";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { ModalAllder } from "layouts/ModalAllder";
import ListGroup from "react-bootstrap/ListGroup";
import LoadPR from "layouts/LoadDucument/PurchaseRequisition";
import { NumericFormat } from "react-number-format";
import { DndContext, closestCenter, KeyboardSensor, useSensor, useSensors, DragOverlay, MouseSensor, TouchSensor } from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import { arrayMove, SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import dayjs from "dayjs";
import { useGetAllMember } from "hooks/member/useGetAllMember";
import { Autocomplete, CircularProgress, Popper, TextField } from "@mui/material";
import { initStateMemberData } from "mocks/memberData";
import { ProductSelect } from "layouts/ProductSelect";
import Productrow from "layouts/Productrow";
import { getProductInit } from "utils/HelperProduct";
import { calPriceByMstCategoryPriceTax, getDiscountValue, getEmpFullNameTHByEmpData, NumberFormat, setProductRowVatByMstCategoryPrice, WDA } from "utils/HelperFunction";
import { ProductHistory } from "layouts/ProductHistory";
import { ProductTableSort } from "layouts/ProductTableSort";
import ProductrowV2 from "layouts/ProductrowV2";
import { ProductTableDisplay } from "layouts/ProductTableDisplay";
import moment from "moment";
import { getDateInvoiceByStatus, getDeliveredStatusList, handleOnSelectProductRowOverrideInvoice, handleRowSelectOverrideInvoice, isInvoiceOverDue, loadDocDataFromDoProcess } from "utils/HelperInvoiceFunction";
import { columnPresets } from "hooks/product/columnPresets";
import TagSelected from "fragments/TagSelected";
import { mappingSearchMember } from "utils/HelperMemberFunction";
import InvoiceFooterSubmit from "layouts/InvoiceFooterSubmit";
import InvoiceDocStatus from "layouts/InvoiceDocStatus";
import InvoiceModalGroup from "layouts/InvoiceModalGroup";
import DocStatus from "layouts/DocStatus";
import { ProductTableFilterDisplay } from "layouts/ProductTableFilterDisplay";
import useInvoiceLoadingSync from "hooks/invoice/useInvoiceLoadingSync";
import DiscountInput from "fragments/DiscountInput";
import LoadDeliverOrder from "layouts/LoadDucument/LoadDeliverOrder";
import TaxInvoiceSwitch from "fragments/TaxInvoiceSwitch";
import InvoicePayment from "layouts/InvoicePayment";
import { useInvoiceInitContext } from "contexts/invoicePage/InvoiceInitContext";
import { useInvoiceFormContext } from "contexts/invoicePage/InvoiceFormContext";
import TabInvoiceBtn from "fragments/TabInvoiceBtn";
export function InvoiceCreateContent() {
    var _useInvoiceInitContext = useInvoiceInitContext(), options = _useInvoiceInitContext.options, isInitInvoiceLoading = _useInvoiceInitContext.isInitInvoiceLoading, userInfo = _useInvoiceInitContext.userInfo, companyInfo = _useInvoiceInitContext.companyInfo, formdata = _useInvoiceInitContext.formdata, setFormdata = _useInvoiceInitContext.setFormdata, modalInvoiceModalState = _useInvoiceInitContext.modalInvoiceModalState, sumproductPrice = _useInvoiceInitContext.sumproductPrice, setSumproductPrice = _useInvoiceInitContext.setSumproductPrice, sumproductNoVat = _useInvoiceInitContext.sumproductNoVat, setSumproductNoVat = _useInvoiceInitContext.setSumproductNoVat, sumproductZeroVat = _useInvoiceInitContext.sumproductZeroVat, setSumproductZeroVat = _useInvoiceInitContext.setSumproductZeroVat, sumproductSevenVat = _useInvoiceInitContext.sumproductSevenVat, setSumproductSevenVat = _useInvoiceInitContext.setSumproductSevenVat, sumproductBeforeVat = _useInvoiceInitContext.sumproductBeforeVat, setSumproductBeforeVat = _useInvoiceInitContext.setSumproductBeforeVat, sumproductOrdered = _useInvoiceInitContext.sumproductOrdered, setSumproductOrdered = _useInvoiceInitContext.setSumproductOrdered;
    var _useInvoiceFormContext = useInvoiceFormContext(), schema = _useInvoiceFormContext.schema, formdisabled = _useInvoiceFormContext.formdisabled, setFormdisabled = _useInvoiceFormContext.setFormdisabled, pdata = _useInvoiceFormContext.pdata, setPdata = _useInvoiceFormContext.setPdata, formatResult = _useInvoiceFormContext.formatResult, handleMainSubmit = _useInvoiceFormContext.handleMainSubmit, handlePreSubmit = _useInvoiceFormContext.handlePreSubmit, headerName = _useInvoiceFormContext.headerName, isFormInvoiceLoading = _useInvoiceFormContext.isFormInvoiceLoading, setGenReceipt = _useInvoiceFormContext.setGenReceipt, tab = _useInvoiceFormContext.tab, setTab = _useInvoiceFormContext.setTab, productRow = _useInvoiceFormContext.productRow, setProductRow = _useInvoiceFormContext.setProductRow, columnsort = _useInvoiceFormContext.columnsort, setColumnsort = _useInvoiceFormContext.setColumnsort, attachments = _useInvoiceFormContext.attachments, setAttachments = _useInvoiceFormContext.setAttachments, attachmentDeliver = _useInvoiceFormContext.attachmentDeliver, tagselected = _useInvoiceFormContext.tagselected, setTagSelected = _useInvoiceFormContext.setTagSelected, updateDocIds = _useInvoiceFormContext.updateDocIds;
    var invoiceID = useParams().invoiceID;
    var _useState = _sliced_to_array(useState({
        onlyReceiveProduct: {
            isActive: false,
            name: "แสดงเฉพาะสินค้าส่งแล้ว"
        }
    }), 2), filterDisplay = _useState[0], setFilterDisplay = _useState[1];
    var docFileInputRef = useRef(null);
    var handlePreviewFile = function(e) {
        if (e.target.files[0]) {
            var reader = new FileReader();
            var file = e.target.files[0].name.split(".");
            var blobUrl = URL.createObjectURL(e.target.files[0]);
            reader.addEventListener("load", function() {
                var newId = nanoid();
                setAttachments(function(prev) {
                    return _to_consumable_array(prev).concat([
                        {
                            id: newId,
                            docId: "",
                            docFile: e.target.files[0].name,
                            docFileType: file[1],
                            docFileData: reader.result,
                            docUrl: blobUrl
                        }
                    ]);
                });
            });
            reader.readAsDataURL(e.target.files[0]);
        }
    };
    var deleteDocument = function(removeId) {
        setAttachments(function(doc) {
            return doc.filter(function(item) {
                return item.id !== removeId;
            });
        });
        if (docFileInputRef.current) {
            docFileInputRef.current.value = "";
        }
    };
    var _useState1 = _sliced_to_array(useState(true), 2), Collapse = _useState1[0], setCollapse = _useState1[1];
    var containerAutocomplete1 = useRef(null);
    var _useState2 = _sliced_to_array(useState(""), 2), inputMemberValue = _useState2[0], setInputMemberValue = _useState2[1];
    var _useGetAllMember = useGetAllMember({
        isBoSale: true
    }), members = _useGetAllMember.members, handleSearchChange = _useGetAllMember.handleSearchChange, isGetAllMemberLoading = _useGetAllMember.isGetAllMemberLoading;
    useInvoiceLoadingSync({
        loadingStates: [
            isInitInvoiceLoading,
            isFormInvoiceLoading
        ]
    });
    return /*#__PURE__*/ _jsxs("div", {
        className: "document-page invoice-page",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-1",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "ขาย"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "ใบแจ้งหนี้ INVOICE"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("li", {
                                    className: "breadcrumb-item active tc-1 ",
                                    "aria-current": "page",
                                    children: [
                                        headerName,
                                        " "
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-4",
                        children: headerName
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Formik, {
                enableReinitialize: true,
                initialValues: formdata,
                validationSchema: schema,
                onSubmit: function(values, param) {
                    var resetForm = param.resetForm;
                    handleMainSubmit({
                        values: values,
                        resetForm: resetForm
                    });
                },
                children: function(param) {
                    var handleSubmit = param.handleSubmit, handleChange = param.handleChange, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue, setErrors = param.setErrors, setValues = param.setValues;
                    return /*#__PURE__*/ _jsxs(Form, {
                        noValidate: true,
                        onSubmit: function(e) {
                            e.preventDefault();
                            handlePreSubmit({
                                productRow: productRow,
                                setFieldValue: setFieldValue,
                                handleSubmit: handleSubmit,
                                values: values,
                                attachments: attachments,
                                attachmentDeliver: attachmentDeliver,
                                tagselected: tagselected,
                                updateDocIds: updateDocIds,
                                setModalAlert: modalInvoiceModalState.setModalAlert,
                                setErrors: setErrors
                            });
                        },
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "mx-auto mb-4 pb-3 pagezoom",
                                style: {
                                    maxWidth: "700px"
                                },
                                children: /*#__PURE__*/ _jsx(Steps, {
                                    docStatus: invoiceID ? values.dim_mst_invoice_status_id : 0,
                                    values: values
                                })
                            }),
                            invoiceID && values.canceledByEmp && /*#__PURE__*/ _jsxs("div", {
                                className: "cancel-warn pagezoom mb-4",
                                children: [
                                    /*#__PURE__*/ _jsx("img", {
                                        src: "/images/icon-warn-red.png"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fs-16",
                                        children: "".concat(moment(values.canceled_at, "YYYY-MM-DD HH:mm:ss").add(7, "hours").format("DD/MM/YYYY HH:mm:ss"), " โดย ").concat(getEmpFullNameTHByEmpData(values.canceledByEmp), " “").concat(values.not_approve_reason, "”")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("fieldset", {
                                disabled: formdisabled,
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "card pagezoom card-st-3 mb-4",
                                    style: {
                                        minWidth: "1000px"
                                    },
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "card-body px-xl-3",
                                        children: /*#__PURE__*/ _jsx("div", {
                                            id: "",
                                            children: /*#__PURE__*/ _jsx("div", {
                                                children: /*#__PURE__*/ _jsx("div", {
                                                    className: "pt-3 px-3",
                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                        className: "row gx-xl-4",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-12",
                                                                children: invoiceID && values.dimMstInvoiceStatus ? /*#__PURE__*/ _jsx("div", {
                                                                    className: "d-flex justify-content-end align-items-center h-100",
                                                                    children: /*#__PURE__*/ _jsx("div", {
                                                                        className: "flex items-center flex-col",
                                                                        children: /*#__PURE__*/ _jsx(InvoiceDocStatus, {
                                                                            statusID: values.dimMstInvoiceStatus.id,
                                                                            statusName: values.dimMstInvoiceStatus.name,
                                                                            isOverDue: isInvoiceOverDue({
                                                                                dueDate: values.doc_due_date,
                                                                                nowDate: moment().format("YYYY-MM-DD"),
                                                                                statusID: values.dimMstInvoiceStatus.id
                                                                            }),
                                                                            className: "fs-18"
                                                                        }, "so-status-".concat(values.dimMstInvoiceStatus.id))
                                                                    })
                                                                }) : null
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: [
                                                                                "เลขที่ใบแจ้งหนี้",
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "doc_number",
                                                                            className: "form-control",
                                                                            placeholder: "",
                                                                            value: values.doc_number,
                                                                            onChange: handleChange,
                                                                            isInvalid: !!errors.doc_number,
                                                                            disabled: true
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                    className: "mt-[12px]",
                                                                    children: /*#__PURE__*/ _jsx(LocalizationProvider, {
                                                                        dateAdapter: AdapterDayjs,
                                                                        className: "h-[40px] ",
                                                                        children: /*#__PURE__*/ _jsx("div", {
                                                                            className: "flex",
                                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                                className: "grow ",
                                                                                children: /*#__PURE__*/ _jsx(DatePicker, {
                                                                                    format: "DD/MM/YYYY",
                                                                                    slotProps: {
                                                                                        textField: {
                                                                                            InputLabelProps: {
                                                                                                shrink: true
                                                                                            },
                                                                                            error: !!errors.doc_issue_date
                                                                                        }
                                                                                    },
                                                                                    label: /*#__PURE__*/ _jsxs(_Fragment, {
                                                                                        children: [
                                                                                            "วันที่ออกเอกสาร",
                                                                                            " ",
                                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                                className: "tc-16",
                                                                                                children: "*"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    className: "h-[40px] w-full ",
                                                                                    sx: {
                                                                                        ".MuiInputBase-formControl": _object_spread({
                                                                                            height: "53px",
                                                                                            borderRadius: "8px"
                                                                                        }, formdisabled && {
                                                                                            pointerEvents: "none !important",
                                                                                            backgroundColor: "#F8F8F9 !important"
                                                                                        }),
                                                                                        ".MuiFormLabel-root": {
                                                                                            fontFamily: "Sarabun"
                                                                                        },
                                                                                        ".MuiOutlinedInput-notchedOutline": {
                                                                                            border: "1px solid rgba(76, 78, 100, 0.22)"
                                                                                        }
                                                                                    },
                                                                                    name: "doc_issue_date",
                                                                                    value: values.doc_issue_date ? dayjs(values.doc_issue_date) : dayjs(),
                                                                                    onChange: function(date) {
                                                                                        var formattedDate = dayjs(date).isValid() ? dayjs(date).format("YYYY-MM-DD") : null;
                                                                                        setFieldValue("doc_issue_date", formattedDate);
                                                                                    }
                                                                                })
                                                                            })
                                                                        })
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "col-3 relative",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "tc-16 fs-12 absolute top-[-20px]",
                                                                        children: errors.doc_due_date
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Form.Group, {
                                                                        className: "mt-[12px]",
                                                                        children: /*#__PURE__*/ _jsx(LocalizationProvider, {
                                                                            dateAdapter: AdapterDayjs,
                                                                            className: "h-[40px] ",
                                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                                className: "flex",
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "grow ",
                                                                                    children: /*#__PURE__*/ _jsx(DatePicker, {
                                                                                        format: "DD/MM/YYYY",
                                                                                        slotProps: {
                                                                                            textField: {
                                                                                                InputLabelProps: {
                                                                                                    shrink: true
                                                                                                },
                                                                                                error: !!errors.doc_due_date
                                                                                            }
                                                                                        },
                                                                                        label: /*#__PURE__*/ _jsxs(_Fragment, {
                                                                                            children: [
                                                                                                "วันที่ครบกำหนด",
                                                                                                " ",
                                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                                    className: "tc-16",
                                                                                                    children: "*"
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        className: "h-[40px] w-full ",
                                                                                        sx: {
                                                                                            ".MuiInputBase-formControl": _object_spread({
                                                                                                height: "53px",
                                                                                                borderRadius: "8px"
                                                                                            }, formdisabled && {
                                                                                                pointerEvents: "none !important",
                                                                                                backgroundColor: "#F8F8F9 !important"
                                                                                            }),
                                                                                            ".MuiFormLabel-root": {
                                                                                                fontFamily: "Sarabun"
                                                                                            },
                                                                                            ".MuiOutlinedInput-notchedOutline": {
                                                                                                border: "1px solid rgba(76, 78, 100, 0.22)"
                                                                                            }
                                                                                        },
                                                                                        name: "doc_due_date",
                                                                                        value: values.doc_due_date ? dayjs(values.doc_due_date) : null,
                                                                                        onChange: function(date) {
                                                                                            var formattedDate = dayjs(date).isValid() ? dayjs(date).format("YYYY-MM-DD") : null;
                                                                                            setFieldValue("doc_due_date", formattedDate);
                                                                                        }
                                                                                    })
                                                                                })
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "อ้างอิงระบบ"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "do_doc_number_ref",
                                                                            className: "form-control",
                                                                            placeholder: "",
                                                                            value: values.do_doc_number_ref,
                                                                            onChange: handleChange,
                                                                            isInvalid: !!errors.do_doc_number_ref,
                                                                            disabled: true
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "อ้างอิง"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "refer",
                                                                            className: "form-control",
                                                                            placeholder: "",
                                                                            value: values.refer,
                                                                            onChange: handleChange,
                                                                            isInvalid: !!errors.refer
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: [
                                                                                "ประเภทราคา ",
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    className: "tc-16",
                                                                                    children: "*"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Select, {
                                                                            as: "select",
                                                                            name: "dim_mst_price_category_id",
                                                                            onChange: function(e) {
                                                                                setFieldValue("dim_mst_price_category_id", e.value);
                                                                            },
                                                                            className: "w-100 select-st-1 ".concat(formdisabled || values.fact_new_do_id ? "disabled-select" : "", " ").concat(values.dim_mst_price_category_id ? "" : !!errors.dim_mst_price_category_id ? "is-invalid" : ""),
                                                                            options: options.priceCategory,
                                                                            placeholder: "เลือกประเภทราคา",
                                                                            value: options.priceCategory.filter(function(item) {
                                                                                return item.value === values.dim_mst_price_category_id;
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: [
                                                                                "ประเภทการชำระเงิน",
                                                                                " ",
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    className: "tc-16",
                                                                                    children: "*"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Select, {
                                                                            as: "select",
                                                                            name: "dim_mst_payment_type_id",
                                                                            onChange: function(e) {
                                                                                setFieldValue("dim_mst_payment_type_id", e.value);
                                                                            },
                                                                            className: "w-100 select-st-1 ".concat(formdisabled || values.fact_new_do_id ? "disabled-select" : "", " ").concat(values.dim_mst_payment_type_id ? "" : !!errors.dim_mst_payment_type_id ? "is-invalid" : ""),
                                                                            options: options.paymentType,
                                                                            placeholder: "เลือกประเภทการชำระเงิน",
                                                                            value: options.paymentType.filter(function(item) {
                                                                                return item.value === values.dim_mst_payment_type_id;
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3"
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                    ref: containerAutocomplete1,
                                                                    className: "mt-[12px] relative",
                                                                    children: /*#__PURE__*/ _jsx(Autocomplete, {
                                                                        disablePortal: true,
                                                                        options: (members === null || members === void 0 ? void 0 : members.data) || [],
                                                                        noOptionsText: inputMemberValue.trim() === "" ? "กรอกข้อมูลเพื่อค้นหา" : "ไม่พบสมาชิกในระบบ",
                                                                        sx: {
                                                                            ".MuiInputBase-formControl": {
                                                                                height: "53px",
                                                                                borderRadius: "8px"
                                                                            },
                                                                            ".MuiFormLabel-root": {
                                                                                fontFamily: "Sarabun"
                                                                            },
                                                                            ".MuiOutlinedInput-notchedOutline": {
                                                                                border: "1px solid rgba(76, 78, 100, 0.22)"
                                                                            }
                                                                        },
                                                                        getOptionLabel: function(option) {
                                                                            var mappingOption = mappingSearchMember(option);
                                                                            return "".concat(mappingOption.customerName);
                                                                        },
                                                                        onInputChange: function(event, newInputValue) {
                                                                            setInputMemberValue(newInputValue);
                                                                            if (newInputValue) {
                                                                                handleSearchChange(newInputValue);
                                                                            } else {
                                                                                setPdata(initStateMemberData);
                                                                            }
                                                                        },
                                                                        onChange: function(event, selectedOption) {
                                                                            if (selectedOption) {
                                                                                var mappingMember = mappingSearchMember(selectedOption);
                                                                                setPdata(mappingMember);
                                                                                setValues(function(prev) {
                                                                                    return _object_spread_props(_object_spread({}, prev), {
                                                                                        fact_member_id: selectedOption.id,
                                                                                        member_address: mappingMember.address
                                                                                    });
                                                                                });
                                                                            } else {
                                                                                setFieldValue("fact_member_id", "");
                                                                            }
                                                                        },
                                                                        PopperComponent: function(props) {
                                                                            return /*#__PURE__*/ _jsx(Popper, _object_spread_props(_object_spread({}, props), {
                                                                                anchorEl: containerAutocomplete1.current,
                                                                                container: containerAutocomplete1.current,
                                                                                modifiers: [
                                                                                    {
                                                                                        name: "applyStyles",
                                                                                        enabled: false
                                                                                    }
                                                                                ],
                                                                                style: {
                                                                                    width: "100%",
                                                                                    position: "absolute",
                                                                                    inset: "unset",
                                                                                    left: 0,
                                                                                    transform: "none",
                                                                                    zIndex: 1300
                                                                                }
                                                                            }));
                                                                        },
                                                                        renderInput: function(params) {
                                                                            return /*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({}, params), {
                                                                                styling: {
                                                                                    height: "54px",
                                                                                    borderRadius: "10px",
                                                                                    boxShadow: "none",
                                                                                    zIndex: 10
                                                                                },
                                                                                sx: {
                                                                                    ".MuiInputBase-formControl": _object_spread({}, (formdisabled || values.fact_new_do_id) && {
                                                                                        pointerEvents: "none !important",
                                                                                        backgroundColor: "#F8F8F9 !important"
                                                                                    })
                                                                                },
                                                                                error: !!errors.fact_member_id,
                                                                                label: "ลูกค้า",
                                                                                InputLabelProps: {
                                                                                    shrink: true
                                                                                },
                                                                                InputProps: _object_spread_props(_object_spread({}, params.InputProps), {
                                                                                    endAdornment: /*#__PURE__*/ _jsxs(React.Fragment, {
                                                                                        children: [
                                                                                            isGetAllMemberLoading ? /*#__PURE__*/ _jsx(CircularProgress, {
                                                                                                color: "inherit",
                                                                                                size: 20
                                                                                            }) : null,
                                                                                            params.InputProps.endAdornment
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            }));
                                                                        },
                                                                        isOptionEqualToValue: function(option, value) {
                                                                            return (option === null || option === void 0 ? void 0 : option.id) === (value === null || value === void 0 ? void 0 : value.id);
                                                                        },
                                                                        renderOption: function(props, option) {
                                                                            return /*#__PURE__*/ _createElement("li", _object_spread_props(_object_spread({}, props), {
                                                                                key: "luid-" + option.id
                                                                            }), formatResult(option));
                                                                        },
                                                                        clearOnBlur: false,
                                                                        filterOptions: function(x) {
                                                                            return x.filter(function(v) {
                                                                                var mappingMember = mappingSearchMember(v);
                                                                                return mappingMember.customerCode || mappingMember.customerName;
                                                                            });
                                                                        },
                                                                        disabled: !!values.fact_new_do_id
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: [
                                                                                "ผู้จัดทำเอกสาร",
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "userManage",
                                                                            className: "form-control",
                                                                            placeholder: "ผู้จัดทำเอกสาร",
                                                                            value: getEmpFullNameTHByEmpData(invoiceID ? values.createdNewInvoiceEmp : userInfo === null || userInfo === void 0 ? void 0 : userInfo.dimNewAlldernowEmp),
                                                                            onChange: handleChange,
                                                                            isInvalid: !!errors.userManage,
                                                                            disabled: true
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-6"
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                    className: "pb-4 pt-3",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "fw-bold fs-18 mb-2",
                                                                            children: "ชื่อลูกค้า"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                                children: pdata.customerName
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                    className: "pb-4 pt-3",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                            className: "fw-bold fs-18 mb-2",
                                                                            children: [
                                                                                "ที่อยู่ ",
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    className: "tc-16",
                                                                                    children: "*"
                                                                                }),
                                                                                errors.member_address && /*#__PURE__*/ _jsx("span", {
                                                                                    className: "tc-16 ms-2 fs-14",
                                                                                    children: errors.member_address
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                                children: pdata.address || "-"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                    className: "pb-4 pt-3",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "fw-bold fs-18 mb-2",
                                                                            children: "เบอร์โทร"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                                children: pdata.phoneNumber
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                    className: "pb-4 pt-3",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "fw-bold fs-18 mb-2",
                                                                            children: "รหัสลูกค้า"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                                children: pdata.customerCode
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: [
                                                                                "สาขาที่เลือก ",
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    className: "tc-16",
                                                                                    children: "*"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Select, {
                                                                            as: "select",
                                                                            name: "dim_branch_id",
                                                                            onChange: function(e) {
                                                                                setFieldValue("dim_branch_id", e.value);
                                                                            },
                                                                            className: "w-100 select-st-1 ".concat(true ? "disabled-select" : "", " ").concat(values.dim_branch_id ? "" : !!errors.dim_branch_id ? "is-invalid" : ""),
                                                                            options: options.branch,
                                                                            placeholder: "เลือกสาขา",
                                                                            value: options.branch.filter(function(item) {
                                                                                return item.value === (options.branch.length === 1 ? 1 : values.dim_branch_id);
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3"
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "col-12 py-3 d-flex",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(TaxInvoiceSwitch, {
                                                                        setFormdata: setFormdata
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("label", {
                                                                        htmlFor: "custom-switch",
                                                                        className: "",
                                                                        children: "ออกใบกำกับภาษี"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mb-4",
                                children: [
                                    /*#__PURE__*/ _jsx(TabInvoiceBtn, {
                                        tab: tab,
                                        setTab: setTab
                                    }),
                                    tab == 1 ? /*#__PURE__*/ _jsx(ProductData, {
                                        values: values,
                                        setFieldValue: setFieldValue,
                                        productRow: productRow,
                                        setProductRow: setProductRow,
                                        sumproductPrice: sumproductPrice,
                                        setSumproductPrice: setSumproductPrice,
                                        sumproductNoVat: sumproductNoVat,
                                        setSumproductNoVat: setSumproductNoVat,
                                        sumproductZeroVat: sumproductZeroVat,
                                        setSumproductZeroVat: setSumproductZeroVat,
                                        sumproductSevenVat: sumproductSevenVat,
                                        setSumproductSevenVat: setSumproductSevenVat,
                                        sumproductBeforeVat: sumproductBeforeVat,
                                        setSumproductBeforeVat: setSumproductBeforeVat,
                                        sumproductOrdered: sumproductOrdered,
                                        setSumproductOrdered: setSumproductOrdered,
                                        optionsMstDiscountType: options.discountType,
                                        optionsMstVat: options.vat,
                                        optionNewItemCol: options.invoiceItemCol,
                                        columnsort: columnsort,
                                        setColumnsort: setColumnsort,
                                        setFormdata: setFormdata,
                                        setPdata: setPdata,
                                        formdisabled: formdisabled,
                                        filterDisplay: filterDisplay,
                                        setFilterDisplay: setFilterDisplay,
                                        invoiceID: invoiceID
                                    }) : /*#__PURE__*/ _jsx(InvoicePayment, {})
                                ]
                            }),
                            tab === 1 && /*#__PURE__*/ _jsx("fieldset", {
                                disabled: formdisabled,
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "card card-st-3 mb-4 pagezoom",
                                    style: {
                                        minWidth: "1000px"
                                    },
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "card-body px-xl-3",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "row",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col",
                                                        children: /*#__PURE__*/ _jsx("div", {
                                                            className: "fs-20 fw-bold",
                                                            children: "สรุปข้อมูล"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-auto",
                                                        children: /*#__PURE__*/ _jsx("table", {
                                                            className: "table table-d1 table-borderless",
                                                            children: /*#__PURE__*/ _jsxs("tbody", {
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                className: "text-end",
                                                                                children: "มูลค่าสินค้าก่อนส่วนลด"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold text-end",
                                                                                    style: {
                                                                                        color: "#636578"
                                                                                    },
                                                                                    children: NumberFormat(sumproductPrice, 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "d-flex align-items-center",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("div", {
                                                                                            className: "me-2",
                                                                                            children: "ส่วนลด "
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                                            className: "d-flex align-items-center",
                                                                                            children: [
                                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                                    type: "number",
                                                                                                    name: "discount_value",
                                                                                                    className: "form-control",
                                                                                                    placeholder: "",
                                                                                                    value: values.discount_value,
                                                                                                    onChange: handleChange,
                                                                                                    isInvalid: !!errors.discount_value,
                                                                                                    style: {
                                                                                                        borderRight: 0,
                                                                                                        borderTopRightRadius: 0,
                                                                                                        borderBottomRightRadius: 0,
                                                                                                        width: "80px"
                                                                                                    }
                                                                                                }),
                                                                                                /*#__PURE__*/ _jsx(Select, {
                                                                                                    as: "select",
                                                                                                    name: "dim_mst_discount_type_id",
                                                                                                    onChange: function(e) {
                                                                                                        setFieldValue("dim_mst_discount_type_id", e.value);
                                                                                                    },
                                                                                                    className: "w-100  select-st-2 ".concat(formdisabled ? "disabled-select" : ""),
                                                                                                    options: options.discountType,
                                                                                                    placeholder: "",
                                                                                                    value: options.discountType.filter(function(item) {
                                                                                                        return item.value === values.dim_mst_discount_type_id;
                                                                                                    }),
                                                                                                    style: {
                                                                                                        borderLeft: 0,
                                                                                                        borderTopLeftRadius: 0,
                                                                                                        borderBottomLeftRadius: 0,
                                                                                                        width: "80px"
                                                                                                    }
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx(DiscountInput, {
                                                                                    sumproductPrice: sumproductPrice
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                className: "text-end",
                                                                                children: "มูลค่าสินค้าหลังหักส่วนลด"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold text-end",
                                                                                    style: {
                                                                                        color: "#636578"
                                                                                    },
                                                                                    children: values.dim_mst_discount_type_id === 1 ? NumberFormat(sumproductPrice * ((100 - values.discount_value) * 0.01), 2) : NumberFormat(sumproductPrice - values.discount_value, 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-auto",
                                                        children: /*#__PURE__*/ _jsx("table", {
                                                            className: "table table-d1 table-borderless",
                                                            children: /*#__PURE__*/ _jsxs("tbody", {
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                className: "text-end",
                                                                                children: "มูลค่าสินค้ายกเว้นภาษี"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold text-end",
                                                                                    style: {
                                                                                        color: "#636578"
                                                                                    },
                                                                                    children: NumberFormat(WDA(sumproductNoVat, sumproductBeforeVat, getDiscountValue(values.dim_mst_discount_type_id, sumproductPrice, values.discount_value), false), 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                className: "text-end",
                                                                                children: "มูลค่าสินค้าภาษี 0 %"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold text-end",
                                                                                    style: {
                                                                                        color: "#636578"
                                                                                    },
                                                                                    children: NumberFormat(WDA(sumproductZeroVat, sumproductBeforeVat, getDiscountValue(values.dim_mst_discount_type_id, sumproductPrice, values.discount_value), false), 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                className: "text-end",
                                                                                children: "มูลค่าสินค้าภาษี 7 %"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold text-end",
                                                                                    style: {
                                                                                        color: "#636578"
                                                                                    },
                                                                                    children: NumberFormat(WDA(sumproductSevenVat, sumproductBeforeVat, getDiscountValue(values.dim_mst_discount_type_id, sumproductPrice, values.discount_value), true), 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                className: "text-end",
                                                                                children: "ภาษีมูลค่าเพิ่ม"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold text-end",
                                                                                    style: {
                                                                                        color: "#636578"
                                                                                    },
                                                                                    children: NumberFormat(WDA(sumproductSevenVat, sumproductBeforeVat, getDiscountValue(values.dim_mst_discount_type_id, sumproductPrice, values.discount_value), true) * 0.07, 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "col-auto",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "mb-3 mt-2",
                                                                children: " มูลค่าสุทธิรวม"
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "text-white fs-24",
                                                                style: {
                                                                    background: "#FF6B00",
                                                                    padding: "12px 20px",
                                                                    borderRadius: "8px"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        children: values.dim_mst_discount_type_id === 1 ? NumberFormat(sumproductPrice * ((100 - values.discount_value) * 0.01), 2) : NumberFormat(sumproductPrice - values.discount_value, 2)
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        className: "fs-14 ms-2",
                                                                        children: "บาท"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            Collapse ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-6",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-3",
                                                                    controlId: "exampleForm.ControlTextarea1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "fw-bold fs-18",
                                                                            children: "หมายเหตุ"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            as: "textarea",
                                                                            rows: 3,
                                                                            name: "remark",
                                                                            value: values.remark,
                                                                            onChange: handleChange
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-6 tag-st-1",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-3",
                                                                    controlId: "exampleForm.ControlTextarea1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "fw-bold fs-18",
                                                                            children: "แท็ก"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(TagSelected, {
                                                                            tagselected: tagselected,
                                                                            setTagSelected: setTagSelected,
                                                                            formdisabled: formdisabled
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("hr", {
                                                        className: "my-4",
                                                        style: {
                                                            opacity: 0.1
                                                        }
                                                    })
                                                ]
                                            }) : "",
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "d-flex justify-content-end align-items-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx("button", {
                                                        type: "button",
                                                        className: "btn btn-link",
                                                        style: {
                                                            color: "#FF6B00"
                                                        },
                                                        onClick: function() {
                                                            setCollapse(false);
                                                        },
                                                        disabled: !Collapse,
                                                        children: "ย่อ"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        children: "/"
                                                    }),
                                                    /*#__PURE__*/ _jsx("button", {
                                                        type: "button",
                                                        className: "btn btn-link",
                                                        style: {
                                                            color: "#FF6B00"
                                                        },
                                                        onClick: function() {
                                                            setCollapse(true);
                                                        },
                                                        disabled: Collapse,
                                                        children: "ขยาย"
                                                    })
                                                ]
                                            }),
                                            Collapse ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fw-bold fs-18 mb-3",
                                                        children: "ไฟล์แนบ"
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "pb-4",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("button", {
                                                                type: "button",
                                                                className: "btn  btn-upload-file mb-4",
                                                                onClick: function() {
                                                                    return document.getElementById("fileUpload").click();
                                                                },
                                                                children: "อัพโหลดไฟล์แนบ"
                                                            }),
                                                            /*#__PURE__*/ _jsx("input", {
                                                                type: "file",
                                                                name: "",
                                                                className: "fileUpload hide-input",
                                                                id: "fileUpload",
                                                                accept: ".pdf",
                                                                onChange: function(e) {
                                                                    handlePreviewFile(e);
                                                                },
                                                                ref: docFileInputRef
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "d-flex align-items-center flex-wrap",
                                                                children: attachments.map(function(item, index) {
                                                                    return /*#__PURE__*/ _jsxs("div", {
                                                                        className: "d-flex align-items-center me-3 mb-3",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "me-3",
                                                                                children: index + 1
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("a", {
                                                                                href: "".concat(item.docUrl),
                                                                                target: "_blank",
                                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "docfile",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "icon ".concat(item.docFileType)
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "name fs-18",
                                                                                            children: item.docFile
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("button", {
                                                                                type: "button",
                                                                                className: "btn  btn-delete-file-cross ms-3",
                                                                                onClick: function() {
                                                                                    return deleteDocument(item.id);
                                                                                }
                                                                            })
                                                                        ]
                                                                    }, index);
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }) : ""
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx(InvoiceFooterSubmit, {
                                setFieldValue: setFieldValue,
                                modalInvoiceModalState: modalInvoiceModalState,
                                values: values,
                                productRow: productRow,
                                formdisabled: formdisabled,
                                setFormdisabled: setFormdisabled,
                                companyInfo: companyInfo,
                                setGenReceipt: setGenReceipt,
                                options: options
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "py-5"
                            }),
                            /*#__PURE__*/ _jsx(InvoiceModalGroup, {
                                setFieldValue: setFieldValue,
                                handleChange: handleChange,
                                values: values,
                                modalInvoiceModalState: modalInvoiceModalState
                            })
                        ]
                    });
                }
            })
        ]
    });
}
function ProductData(param) {
    var values = param.values, setFieldValue = param.setFieldValue, optionsMstDiscountType = param.optionsMstDiscountType, optionsMstVat = param.optionsMstVat, optionNewItemCol = param.optionNewItemCol, productRow = param.productRow, setProductRow = param.setProductRow, sumproductPrice = param.sumproductPrice, setSumproductPrice = param.setSumproductPrice, sumproductNoVat = param.sumproductNoVat, setSumproductNoVat = param.setSumproductNoVat, sumproductZeroVat = param.sumproductZeroVat, setSumproductZeroVat = param.setSumproductZeroVat, sumproductSevenVat = param.sumproductSevenVat, setSumproductSevenVat = param.setSumproductSevenVat, sumproductBeforeVat = param.sumproductBeforeVat, setSumproductBeforeVat = param.setSumproductBeforeVat, sumproductOrdered = param.sumproductOrdered, setSumproductOrdered = param.setSumproductOrdered, columnsort = param.columnsort, setColumnsort = param.setColumnsort, setFormdata = param.setFormdata, setPdata = param.setPdata, formdisabled = param.formdisabled, filterDisplay = param.filterDisplay, setFilterDisplay = param.setFilterDisplay, invoiceID = param.invoiceID;
    var addProductRow = function(num) {
        for(var i = 0; i < num; i++){
            setProductRow(function(row) {
                return _to_consumable_array(row).concat([
                    getProductInit()
                ]);
            });
        }
    };
    var checkLength = productRow.filter(function(row) {
        return row.is_checked === true;
    });
    useEffect(function() {
        if (productRow.length <= 0) {
            addProductRow(4);
        }
    }, []);
    var _useState = _sliced_to_array(useState(0), 2), rowCount = _useState[0], setRowCount = _useState[1];
    var _useState1 = _sliced_to_array(useState(0), 2), sumproductQty = _useState1[0], setSumproductQty = _useState1[1];
    var _useState2 = _sliced_to_array(useState(0), 2), sumUms = _useState2[0], setSumUms = _useState2[1];
    var _useState3 = _sliced_to_array(useState(0), 2), sumProductVat = _useState3[0], setSumProductVat = _useState3[1];
    var sumQty = function(productRow) {
        var qty = 0;
        var price = 0;
        var priceBeforeVat = 0;
        var priceNoVat = 0;
        var priceZeroVat = 0;
        var priceSevenVat = 0;
        var priceVat = 0;
        var ordered = 0;
        var ums = 0;
        productRow.forEach(function(pd) {
            var productQty = parseFloat(pd.productQty);
            var productPrice = parseFloat(pd.productPrice);
            var productRatioUnit = parseInt(pd.productRatioUnit);
            var productOrdered = parseInt(pd.productOrdered);
            var hasValidQty = productQty > 0;
            var hasValidPrice = productPrice > 0;
            // Calculate price and priceBeforeVat if both quantity and price are valid
            if (hasValidQty) {
                qty += productQty;
                ums += productRatioUnit * productQty;
                ordered += productOrdered;
            }
            if (hasValidQty && hasValidPrice) {
                price += calPriceByMstCategoryPriceTax(pd, values.dim_mst_price_category_id, false);
                priceBeforeVat += calPriceByMstCategoryPriceTax(pd, values.dim_mst_price_category_id, true);
                // Calculate prices based on VAT type
                switch(parseInt(pd.dim_mst_vat_id)){
                    case 1:
                        priceNoVat += calPriceByMstCategoryPriceTax(pd, values.dim_mst_price_category_id, true);
                        break;
                    case 2:
                        priceZeroVat += calPriceByMstCategoryPriceTax(pd, values.dim_mst_price_category_id, true);
                        break;
                    case 3:
                        priceSevenVat += calPriceByMstCategoryPriceTax(pd, values.dim_mst_price_category_id, true);
                        break;
                    default:
                        console.log(pd.dim_mst_vat_id);
                        break;
                }
                priceVat += calPriceByMstCategoryPriceTax(pd, values.dim_mst_price_category_id, false) - calPriceByMstCategoryPriceTax(pd, values.dim_mst_price_category_id, true);
            }
        });
        setSumproductPrice(price);
        setSumproductBeforeVat(priceBeforeVat);
        setSumproductNoVat(priceNoVat);
        setSumproductZeroVat(priceZeroVat);
        setSumproductSevenVat(priceSevenVat);
        setSumProductVat(priceVat);
        setSumproductQty(qty);
        setSumUms(ums);
        setSumproductOrdered(ordered);
    };
    useEffect(function() {
        if (values.dim_mst_price_category_id == 3) {
            setProductRowVatByMstCategoryPrice(values.dim_mst_price_category_id, setProductRow);
        }
    }, [
        values.dim_mst_price_category_id
    ]);
    useEffect(function() {
        setRowCount(productRow.length);
        sumQty(productRow);
    // const product = productRow.filter((prev) => prev.productCode !== "");
    // setFieldValue("products", productRow);
    // setProductRow(product);
    }, [
        productRow,
        values.dim_mst_price_category_id
    ]);
    var _useState4 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 1400,
        height: 650,
        pin: false,
        mode: "normal",
        modalname: "invoice-product-select"
    }), 2), modal = _useState4[0], setModal = _useState4[1];
    var _useState5 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 530,
        height: 450,
        pin: false,
        mode: "normal",
        modalname: "invoice-product-sort"
    }), 2), modalSort = _useState5[0], setModalSort = _useState5[1];
    var _useState6 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 530,
        height: 570,
        pin: false,
        mode: "normal",
        modalname: "invoice-product-display"
    }), 2), modalDisplayColumn = _useState6[0], setModalDisplayColumn = _useState6[1];
    var _useState7 = _sliced_to_array(useState(null), 2), documentType = _useState7[0], setDocumentType = _useState7[1];
    var _useState8 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 530,
        height: 670,
        pin: false,
        mode: "normal",
        modalname: "qo-load-document"
    }), 2), modalLoadDocument = _useState8[0], setModalLoadDocument = _useState8[1];
    var _useState9 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 1400,
        height: 700,
        pin: false,
        mode: "normal",
        modalname: "qo-select-document"
    }), 2), modalSelectDocument = _useState9[0], setModalSelectDocument = _useState9[1];
    var _useState10 = _sliced_to_array(useState({
        barcode: false,
        supplierCode: false,
        productsOrdered: false,
        ums: false,
        vat: false,
        valueIncludingTax: false
    }), 2), columdisplay = _useState10[0], setColumDisplay = _useState10[1];
    var _useState11 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 530,
        height: 570,
        pin: false,
        mode: "normal",
        modalname: "invoice-product-filter"
    }), 2), modalDisplayFilter = _useState11[0], setModalDisplayFilter = _useState11[1];
    var _useState12 = _sliced_to_array(useState([]), 2), historyProduct = _useState12[0], setHistoryProduct = _useState12[1];
    var _useState13 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 1200,
        height: 600,
        pin: false,
        mode: "normal",
        modalname: "product-history"
    }), 2), modalProductHistory = _useState13[0], setModalProductHistory = _useState13[1];
    useEffect(function() {
        var idisplay = localStorage.getItem("columdisplay");
        if (idisplay) {
            setColumDisplay(JSON.parse(idisplay));
        }
    }, []);
    var items = useMemo(function() {
        return productRow === null || productRow === void 0 ? void 0 : productRow.map(function(param) {
            var rowID = param.rowID;
            return rowID;
        });
    }, [
        productRow
    ]);
    var sensors = useSensors(useSensor(MouseSensor, {}), useSensor(TouchSensor, {}), useSensor(KeyboardSensor, {}));
    var _useState14 = _sliced_to_array(useState(false), 2), customSort = _useState14[0], setCustomSort = _useState14[1];
    var _useState15 = _sliced_to_array(useState(), 2), activeId = _useState15[0], setActiveId = _useState15[1];
    function handleDragStart(event) {
        setActiveId(event.active.id);
        var active = event.active, over = event.over;
    // console.log(event)
    }
    function handleDragEnd(event) {
        var active = event.active, over = event.over;
        if (active.id !== over.id) {
            setProductRow(function(productRow) {
                var oldIndex = items.indexOf(active.id);
                var newIndex = items.indexOf(over.id);
                return arrayMove(productRow, oldIndex, newIndex);
            });
        }
        setActiveId(null);
    }
    function handleDragCancel() {
        setActiveId(null);
    }
    var selectedRow = useMemo(function() {
        if (!activeId) {
            return null;
        }
        var row = productRow.filter(function(prev) {
            return prev.rowID == activeId;
        });
        return row;
    }, [
        activeId
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modal,
                setModal: setModal,
                htitle: "เพิ่มสินค้าหลายรายการ",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(ProductSelect, {
                    productRow: productRow,
                    setProductRow: setProductRow,
                    addProductRow: addProductRow,
                    optionsMstVat: optionsMstVat,
                    values: values,
                    handleRowSelectOverride: handleRowSelectOverrideInvoice,
                    docType: "INVOICE"
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalSort,
                setModal: setModalSort,
                htitle: "จัดเรียง",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(ProductTableSort, {
                    columnsort: columnsort,
                    setColumnsort: setColumnsort,
                    columnoption: optionNewItemCol,
                    setCustomSort: setCustomSort,
                    setModal: setModalSort,
                    productRow: productRow,
                    setProductRow: setProductRow,
                    setFieldValue: setFieldValue,
                    fieldName: "fact_item_do_col_sorts"
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalDisplayColumn,
                setModal: setModalDisplayColumn,
                htitle: "ตัวเลือกการแสดงผล INVOICE",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(ProductTableDisplay, {
                    columdisplay: columdisplay,
                    setModalDisplayColumn: setModalDisplayColumn,
                    setColumDisplay: setColumDisplay,
                    columdisplayName: "columdisplay"
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalProductHistory,
                setModal: setModalProductHistory,
                htitle: "ดูประวัติสินค้า",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(ProductHistory, {
                    historyProduct: historyProduct,
                    setModalProductHistory: setModalProductHistory
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalSelectDocument,
                setModal: setModalSelectDocument,
                htitle: "โหลดเอกสาร",
                hbtn: true,
                children: documentType
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalDisplayFilter,
                setModal: setModalDisplayFilter,
                htitle: "ตัวกรอง",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(ProductTableFilterDisplay, {
                    filterDisplay: filterDisplay,
                    filterdisplayName: "filterdisplay",
                    setModalDisplayFilter: setModalDisplayFilter,
                    setFilterDisplay: setFilterDisplay
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "pagezoom",
                children: checkLength.length > 0 ? /*#__PURE__*/ _jsxs("div", {
                    className: "mb-3",
                    children: [
                        /*#__PURE__*/ _jsx("button", {
                            className: "btn btn-st-x1 me-2",
                            type: "button",
                            onClick: function() {
                                setHistoryProduct(checkLength);
                                setModalProductHistory(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true
                                    });
                                });
                            },
                            disabled: checkLength.length != 1,
                            children: "ดูประวัติสินค้า"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            className: "btn btn-st-x1 me-2",
                            onClick: function() {
                                var checkLenght = productRow.filter(function(item) {
                                    return item.is_checked === true;
                                }).length;
                                setProductRow(function(productRow) {
                                    return productRow.filter(function(item) {
                                        return item.is_checked !== true;
                                    });
                                });
                                addProductRow(checkLenght);
                            },
                            disabled: values.fact_new_do_id,
                            children: "ลบที่เลือก"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            className: "btn btn-st-x1 me-2",
                            onClick: function() {
                                setProductRow(function(prev) {
                                    return prev.map(function(el) {
                                        return _object_spread_props(_object_spread({}, el), {
                                            is_checked: false
                                        });
                                    });
                                });
                            },
                            children: "ยกเลิก"
                        })
                    ]
                }) : customSort ? /*#__PURE__*/ _jsxs("div", {
                    className: "mb-3 d-flex align-items-center",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "alert-w",
                            children: "กรุณาเลือกที่แถวเพื่อจัดลำดับ"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            onClick: function() {
                                setCustomSort(false);
                            },
                            className: "btn btn-st-x1 me-2",
                            children: "บันทึกการจัดเรียง"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-st-x1 me-2",
                            onClick: function() {
                                setCustomSort(false);
                            },
                            children: "ยกเลิกการจัดเรียง"
                        })
                    ]
                }) : /*#__PURE__*/ _jsxs("div", {
                    className: "mb-3 flex",
                    children: [
                        /*#__PURE__*/ _jsx("fieldset", {
                            disabled: formdisabled,
                            children: /*#__PURE__*/ _jsx("button", {
                                type: "button",
                                className: "btn btn-st-x1 me-2",
                                onClick: function() {
                                    return setModal(function(prev) {
                                        return _object_spread_props(_object_spread({}, prev), {
                                            open: true
                                        });
                                    });
                                },
                                disabled: values.fact_new_do_id,
                                children: "เพิ่มหลายรายการ"
                            })
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-st-x1 me-2",
                            onClick: function() {
                                return setModalSort(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true
                                    });
                                });
                            },
                            children: "จัดเรียง"
                        }),
                        /*#__PURE__*/ _jsxs("fieldset", {
                            disabled: formdisabled,
                            children: [
                                /*#__PURE__*/ _jsx("button", {
                                    type: "button",
                                    className: "btn btn-st-x1 me-2",
                                    onClick: function() {
                                        return setModalLoadDocument(function(prev) {
                                            return _object_spread_props(_object_spread({}, prev), {
                                                open: true
                                            });
                                        });
                                    },
                                    disabled: true,
                                    children: "โหลดเอกสาร"
                                }),
                                /*#__PURE__*/ _jsx("button", {
                                    type: "button",
                                    className: "btn btn-st-x1 me-2",
                                    onClick: function() {
                                        setDocumentType(/*#__PURE__*/ _jsx(LoadDeliverOrder, {
                                            setFormdata: setFormdata,
                                            setPdata: setPdata,
                                            setProductRow: setProductRow,
                                            setModal: setModalSelectDocument,
                                            loadDocDataProcess: loadDocDataFromDoProcess
                                        }));
                                        setModalSelectDocument(function(prev) {
                                            return _object_spread_props(_object_spread({}, prev), {
                                                open: true
                                            });
                                        });
                                    },
                                    children: "โหลดใบจัดส่งสินค้า"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-st-x1 me-2",
                            onClick: function() {
                                setModalDisplayColumn(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true
                                    });
                                });
                            },
                            children: "ตัวเลือกแสดงผล"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs("fieldset", {
                disabled: formdisabled,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "pagezoom",
                        style: {
                            overflowX: "auto",
                            maxWidth: "100%",
                            overflowY: "hidden",
                            paddingBottom: "20px"
                        },
                        children: /*#__PURE__*/ _jsxs(DndContext, {
                            sensors: sensors,
                            collisionDetection: closestCenter,
                            onDragEnd: handleDragEnd,
                            onDragCancel: handleDragCancel,
                            onDragStart: handleDragStart,
                            modifiers: [
                                restrictToVerticalAxis
                            ],
                            children: [
                                /*#__PURE__*/ _jsx(SortableContext, {
                                    items: productRow,
                                    strategy: verticalListSortingStrategy,
                                    children: /*#__PURE__*/ _jsxs("table", {
                                        className: "column_resize_table table1 table-striped ",
                                        style: {
                                            width: "auto"
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx("thead", {
                                                children: /*#__PURE__*/ _jsxs("tr", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                className: "form-check form-check-st-t1",
                                                                children: customSort ? "" : /*#__PURE__*/ _jsx("input", {
                                                                    className: "form-check-input",
                                                                    type: "checkbox",
                                                                    name: "",
                                                                    onChange: function(e) {
                                                                        if (e.target.checked === true) {
                                                                            setProductRow(function(prev) {
                                                                                return prev.map(function(el) {
                                                                                    return _object_spread_props(_object_spread({}, el), {
                                                                                        is_checked: true
                                                                                    });
                                                                                });
                                                                            });
                                                                        } else {
                                                                            setProductRow(function(prev) {
                                                                                return prev.map(function(el) {
                                                                                    return _object_spread_props(_object_spread({}, el), {
                                                                                        is_checked: false
                                                                                    });
                                                                                });
                                                                            });
                                                                        }
                                                                    }
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 35
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "รหัสสินค้า"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 200
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "รายการ"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 200
                                                        }),
                                                        columdisplay.barcode ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {
                                                                    children: "บาร์โค้ด"
                                                                }),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer",
                                                                    minWidth: 100
                                                                })
                                                            ]
                                                        }) : "",
                                                        columdisplay.supplierCode ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {
                                                                    children: "รหัสสินค้าผู้ขาย"
                                                                }),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer",
                                                                    minWidth: 130
                                                                })
                                                            ]
                                                        }) : "",
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "หน่วย"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 100
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            className: "".concat(values.fact_new_do_id ? "!bg-[#565DFF] !text-white" : ""),
                                                            children: values.fact_new_do_id ? "จำนวน DO" : "จำนวน"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer ".concat(values.fact_new_do_id ? "!bg-[#565DFF]" : ""),
                                                            minWidth: 80
                                                        }),
                                                        columdisplay.ums ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {
                                                                    style: {
                                                                        backgroundColor: "#666CFF",
                                                                        color: "#FFF"
                                                                    },
                                                                    children: "จำนวน UMS"
                                                                }),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer bg-666CFF ",
                                                                    minWidth: 100
                                                                })
                                                            ]
                                                        }) : "",
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "ราคา/หน่วย"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 110
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "ประเภทส่วนลด"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 140
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "ส่วนลด/หน่วย"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 120
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "ภาษี"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 80
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "มูลค่าก่อนภาษี"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 100
                                                        }),
                                                        columdisplay.vat ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {
                                                                    children: "ภาษีมูลค่าเพิ่ม"
                                                                }),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer",
                                                                    minWidth: 120
                                                                })
                                                            ]
                                                        }) : "",
                                                        columdisplay.valueIncludingTax ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {
                                                                    children: "มูลค่ารวมภาษี"
                                                                }),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer",
                                                                    minWidth: 100
                                                                })
                                                            ]
                                                        }) : "",
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "หมายเหตุ"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 100
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("tbody", {
                                                children: productRow.map(function(item, index) {
                                                    return /*#__PURE__*/ _jsx(ProductrowV2, {
                                                        item: item,
                                                        index: index,
                                                        setProductRow: setProductRow,
                                                        columdisplay: columdisplay,
                                                        customSort: customSort,
                                                        rowCount: rowCount,
                                                        addProductRow: addProductRow,
                                                        optionsMstDiscountType: optionsMstDiscountType,
                                                        optionsMstVat: optionsMstVat,
                                                        filterDisplay: filterDisplay,
                                                        values: values,
                                                        invoiceID: invoiceID,
                                                        columnPresets: columnPresets.invoice,
                                                        OverrideHandleOnSelect: handleOnSelectProductRowOverrideInvoice
                                                    }, index);
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("tfoot", {
                                                children: /*#__PURE__*/ _jsxs("tr", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("td", {}),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body"
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {}),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body"
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {}),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body"
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {}),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body"
                                                        }),
                                                        columdisplay.barcode ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("td", {}),
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    className: "column_resizer_body"
                                                                })
                                                            ]
                                                        }) : "",
                                                        columdisplay.supplierCode ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("td", {}),
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    className: "column_resizer_body"
                                                                })
                                                            ]
                                                        }) : "",
                                                        /*#__PURE__*/ _jsx("td", {
                                                            children: /*#__PURE__*/ _jsx(Form.Control, {
                                                                type: "text",
                                                                name: "prCode",
                                                                className: "form-control text-center",
                                                                placeholder: "",
                                                                value: sumproductQty,
                                                                disabled: true,
                                                                style: {
                                                                    position: "absolute",
                                                                    right: "-0.5vw",
                                                                    top: "10px"
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body "
                                                        }),
                                                        values.dimMstInvoiceStatus && getDeliveredStatusList.includes(values.dimMstInvoiceStatus.id) ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                                        value: sumproductOrdered,
                                                                        thousandSeparator: ",",
                                                                        decimalScale: 0,
                                                                        fixedDecimalScale: true,
                                                                        customInput: function(e) {
                                                                            return /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "",
                                                                                className: "form-control text-center",
                                                                                placeholder: "",
                                                                                value: e.value,
                                                                                disabled: true,
                                                                                style: {
                                                                                    position: "absolute",
                                                                                    right: "-0.5vw",
                                                                                    top: "10px"
                                                                                }
                                                                            });
                                                                        }
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    className: "column_resizer_body"
                                                                })
                                                            ]
                                                        }) : "",
                                                        columdisplay.ums ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                                        value: sumUms,
                                                                        thousandSeparator: ",",
                                                                        decimalScale: 0,
                                                                        fixedDecimalScale: true,
                                                                        customInput: function(e) {
                                                                            return /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "",
                                                                                className: "form-control text-center",
                                                                                placeholder: "",
                                                                                value: e.value,
                                                                                disabled: true,
                                                                                style: {
                                                                                    position: "absolute",
                                                                                    right: "-0.5vw",
                                                                                    top: "10px"
                                                                                }
                                                                            });
                                                                        }
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    className: "column_resizer_body"
                                                                })
                                                            ]
                                                        }) : "",
                                                        /*#__PURE__*/ _jsx("td", {}),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body"
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {}),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body"
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {}),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body"
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {}),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body"
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                                value: sumproductBeforeVat,
                                                                thousandSeparator: ",",
                                                                decimalScale: 2,
                                                                fixedDecimalScale: true,
                                                                customInput: function(e) {
                                                                    return /*#__PURE__*/ _jsx(Form.Control, {
                                                                        type: "text",
                                                                        name: "",
                                                                        className: "form-control text-end",
                                                                        placeholder: "",
                                                                        value: e.value,
                                                                        disabled: true,
                                                                        style: {
                                                                            position: "absolute",
                                                                            right: "-0.5vw",
                                                                            top: "10px"
                                                                        }
                                                                    });
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body"
                                                        }),
                                                        columdisplay.vat ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                                        value: sumProductVat,
                                                                        thousandSeparator: ",",
                                                                        decimalScale: 2,
                                                                        fixedDecimalScale: true,
                                                                        customInput: function(e) {
                                                                            return /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "",
                                                                                className: "form-control text-end",
                                                                                placeholder: "",
                                                                                value: e.value,
                                                                                disabled: true,
                                                                                style: {
                                                                                    position: "absolute",
                                                                                    right: "-0.5vw",
                                                                                    top: "10px"
                                                                                }
                                                                            });
                                                                        }
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    className: "column_resizer_body"
                                                                })
                                                            ]
                                                        }) : "",
                                                        columdisplay.valueIncludingTax ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                                        value: sumproductPrice,
                                                                        thousandSeparator: ",",
                                                                        decimalScale: 2,
                                                                        fixedDecimalScale: true,
                                                                        customInput: function(e) {
                                                                            return /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "",
                                                                                className: "form-control text-end",
                                                                                placeholder: "",
                                                                                value: e.value,
                                                                                disabled: true,
                                                                                style: {
                                                                                    position: "absolute",
                                                                                    right: "-0.5vw",
                                                                                    top: "10px"
                                                                                }
                                                                            });
                                                                        }
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    className: "column_resizer_body"
                                                                })
                                                            ]
                                                        }) : ""
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(DragOverlay, {
                                    children: /*#__PURE__*/ _jsxs("table", {
                                        className: "column_resize_table table1 table-striped  table-thead-0",
                                        style: {
                                            width: "100%"
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx("thead", {
                                                children: /*#__PURE__*/ _jsxs("tr", {
                                                    style: {
                                                        height: 0
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ _jsx("th", {}),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 35
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {}),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 200
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {}),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 200
                                                        }),
                                                        columdisplay.barcode ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {}),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer",
                                                                    minWidth: 100
                                                                })
                                                            ]
                                                        }) : "",
                                                        columdisplay.supplierCode ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {}),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer",
                                                                    minWidth: 130
                                                                })
                                                            ]
                                                        }) : "",
                                                        /*#__PURE__*/ _jsx("th", {}),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 100
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {}),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 100
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {}),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 100
                                                        }),
                                                        columdisplay.productsOrdered ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {
                                                                    style: {
                                                                        backgroundColor: "#FF731D",
                                                                        color: "#FFF"
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer bg-FF731D",
                                                                    minWidth: 100
                                                                })
                                                            ]
                                                        }) : "",
                                                        columdisplay.ums ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {
                                                                    style: {
                                                                        backgroundColor: "#3FA5FF",
                                                                        color: "#FFF"
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer bg-3FA5FF",
                                                                    "bg-FF731D": true,
                                                                    minWidth: 100
                                                                })
                                                            ]
                                                        }) : "",
                                                        /*#__PURE__*/ _jsx("th", {}),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 110
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {}),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 140
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {}),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 120
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {}),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 80
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {}),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 100
                                                        }),
                                                        columdisplay.vat ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {}),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer",
                                                                    minWidth: 120
                                                                })
                                                            ]
                                                        }) : "",
                                                        columdisplay.valueIncludingTax ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {}),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer",
                                                                    minWidth: 100
                                                                })
                                                            ]
                                                        }) : "",
                                                        /*#__PURE__*/ _jsx("th", {}),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 100
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("tbody", {
                                                children: /*#__PURE__*/ _jsx(Productrow, {
                                                    item: selectedRow ? selectedRow[0] : "",
                                                    index: 0,
                                                    setProductRow: setProductRow,
                                                    columdisplay: columdisplay,
                                                    customSort: customSort,
                                                    values: values
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "mt-4 pagezoom",
                        children: /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            className: "btn-st-3 me-3",
                            onClick: function() {
                                return addProductRow(5);
                            },
                            disabled: values.fact_new_do_id,
                            children: "เพิ่มแถว"
                        })
                    })
                ]
            })
        ]
    });
}
function Steps(param) {
    var docStatus = param.docStatus, values = param.values;
    var steps = [
        "สร้างใบแจ้งหนี้",
        "รออนุมัติ",
        "รอรับชำระ",
        "เกินเวลาชำระ",
        "เสร็จสิ้น"
    ];
    var _useState = _sliced_to_array(useState(docStatus || 0), 2), activeStep = _useState[0], setActiveStep = _useState[1];
    useEffect(function() {
        if (docStatus !== undefined && docStatus !== null) {
            setActiveStep(docStatus);
        }
    }, [
        docStatus
    ]);
    return /*#__PURE__*/ _jsx(Stepper, {
        activeStep: activeStep,
        alternativeLabel: true,
        children: steps.map(function(label) {
            var stepProps = {};
            var labelProps = {};
            return /*#__PURE__*/ _jsx(Step, _object_spread_props(_object_spread({}, stepProps), {
                children: /*#__PURE__*/ _jsxs(StepLabel, _object_spread_props(_object_spread({}, labelProps), {
                    style: {
                        fontSize: "16px"
                    },
                    StepIconProps: {
                        sx: {
                            "&.Mui-active": {
                                color: "#f67f2b"
                            },
                            "&.Mui-completed": {
                                color: "#f67f2b"
                            }
                        }
                    },
                    children: [
                        label,
                        /*#__PURE__*/ _jsx("div", {
                            className: "tc-15",
                            children: getDateInvoiceByStatus({
                                values: values,
                                label: label
                            })
                        })
                    ]
                }))
            }), label);
        })
    });
}
function LoadDocument(param) {
    var setDocumentType = param.setDocumentType, setModalSelectDocument = param.setModalSelectDocument, setModal = param.setModal;
    return /*#__PURE__*/ _jsx("div", {
        className: "p-3",
        children: /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "fs-18 mb-3",
                    children: "ประเภทรายการ"
                }),
                /*#__PURE__*/ _jsxs(Accordion, {
                    alwaysOpen: true,
                    children: [
                        /*#__PURE__*/ _jsxs(Accordion.Item, {
                            eventKey: "0",
                            children: [
                                /*#__PURE__*/ _jsx(Accordion.Header, {
                                    children: "ซื้อ"
                                }),
                                /*#__PURE__*/ _jsx(Accordion.Body, {
                                    className: "p-0",
                                    children: /*#__PURE__*/ _jsxs(ListGroup, {
                                        className: "list-st-1",
                                        children: [
                                            /*#__PURE__*/ _jsxs(ListGroup.Item, {
                                                className: "d-flex align-items-center justify-content-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-16",
                                                        style: {
                                                            width: "150px"
                                                        },
                                                        children: "ใบขอซื้อ"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Button, {
                                                        type: "submit",
                                                        className: "btn-st-3 ",
                                                        onClick: function() {
                                                            setModal(function(prev) {
                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                    open: false
                                                                });
                                                            });
                                                            setModalSelectDocument(function(prev) {
                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                    open: true
                                                                });
                                                            });
                                                            setDocumentType(/*#__PURE__*/ _jsx(LoadPR, {
                                                                setModal: setModalSelectDocument
                                                            }));
                                                        },
                                                        children: "เลือก"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(ListGroup.Item, {
                                                className: "d-flex align-items-center justify-content-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-16",
                                                        style: {
                                                            width: "150px"
                                                        },
                                                        children: "ใบสั่งซื้อ"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Button, {
                                                        type: "submit",
                                                        className: "btn-st-3 ",
                                                        onClick: function() {
                                                            setModal(function(prev) {
                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                    open: false
                                                                });
                                                            });
                                                            setModalSelectDocument(function(prev) {
                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                    open: true
                                                                });
                                                            });
                                                            setDocumentType(/*#__PURE__*/ _jsx(LoadPR, {
                                                                setModal: setModalSelectDocument
                                                            }));
                                                        },
                                                        children: "เลือก"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(Accordion.Item, {
                            eventKey: "1",
                            children: [
                                /*#__PURE__*/ _jsx(Accordion.Header, {
                                    children: "ขาย"
                                }),
                                /*#__PURE__*/ _jsx(Accordion.Body, {
                                    className: "p-0",
                                    children: /*#__PURE__*/ _jsxs(ListGroup, {
                                        className: "list-st-1",
                                        children: [
                                            /*#__PURE__*/ _jsxs(ListGroup.Item, {
                                                className: "d-flex align-items-center justify-content-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-16",
                                                        style: {
                                                            width: "150px"
                                                        },
                                                        children: "ใบเสนอขาย"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Button, {
                                                        type: "submit",
                                                        className: "btn-st-3 ",
                                                        onClick: function() {
                                                            setModal(function(prev) {
                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                    open: false
                                                                });
                                                            });
                                                            setModalSelectDocument(function(prev) {
                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                    open: true
                                                                });
                                                            });
                                                            setDocumentType(/*#__PURE__*/ _jsx(LoadPR, {
                                                                setModal: setModalSelectDocument
                                                            }));
                                                        },
                                                        children: "เลือก"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(ListGroup.Item, {
                                                className: "d-flex align-items-center justify-content-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-16",
                                                        style: {
                                                            width: "150px"
                                                        },
                                                        children: "ใบส่งของ"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Button, {
                                                        type: "submit",
                                                        className: "btn-st-3 ",
                                                        onClick: function() {
                                                            setModal(function(prev) {
                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                    open: false
                                                                });
                                                            });
                                                            setModalSelectDocument(function(prev) {
                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                    open: true
                                                                });
                                                            });
                                                            setDocumentType(/*#__PURE__*/ _jsx(LoadPR, {
                                                                setModal: setModalSelectDocument
                                                            }));
                                                        },
                                                        children: "เลือก"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(Accordion.Item, {
                            eventKey: "2",
                            children: [
                                /*#__PURE__*/ _jsx(Accordion.Header, {
                                    children: "คลัง"
                                }),
                                /*#__PURE__*/ _jsx(Accordion.Body, {
                                    className: "p-0",
                                    children: /*#__PURE__*/ _jsxs(ListGroup, {
                                        className: "list-st-1",
                                        children: [
                                            /*#__PURE__*/ _jsxs(ListGroup.Item, {
                                                className: "d-flex align-items-center justify-content-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-16",
                                                        style: {
                                                            width: "150px"
                                                        },
                                                        children: "ใบรับสินค้า"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Button, {
                                                        type: "submit",
                                                        className: "btn-st-3 ",
                                                        onClick: function() {
                                                            setModal(function(prev) {
                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                    open: false
                                                                });
                                                            });
                                                            setModalSelectDocument(function(prev) {
                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                    open: true
                                                                });
                                                            });
                                                            setDocumentType(/*#__PURE__*/ _jsx(LoadPR, {
                                                                setModal: setModalSelectDocument
                                                            }));
                                                        },
                                                        children: "เลือก"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(ListGroup.Item, {
                                                className: "d-flex align-items-center justify-content-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-16",
                                                        style: {
                                                            width: "150px"
                                                        },
                                                        children: "ใบเบิกสินค้า"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Button, {
                                                        type: "submit",
                                                        className: "btn-st-3 ",
                                                        onClick: function() {
                                                            setModal(function(prev) {
                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                    open: false
                                                                });
                                                            });
                                                            setModalSelectDocument(function(prev) {
                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                    open: true
                                                                });
                                                            });
                                                            setDocumentType(/*#__PURE__*/ _jsx(LoadPR, {
                                                                setModal: setModalSelectDocument
                                                            }));
                                                        },
                                                        children: "เลือก"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(ListGroup.Item, {
                                                className: "d-flex align-items-center justify-content-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-16",
                                                        style: {
                                                            width: "150px"
                                                        },
                                                        children: "ใบโอนย้ายสินค้า"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Button, {
                                                        type: "submit",
                                                        className: "btn-st-3 ",
                                                        onClick: function() {
                                                            setModal(function(prev) {
                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                    open: false
                                                                });
                                                            });
                                                            setModalSelectDocument(function(prev) {
                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                    open: true
                                                                });
                                                            });
                                                            setDocumentType(/*#__PURE__*/ _jsx(LoadPR, {
                                                                setModal: setModalSelectDocument
                                                            }));
                                                        },
                                                        children: "เลือก"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(ListGroup.Item, {
                                                className: "d-flex align-items-center justify-content-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-16",
                                                        style: {
                                                            width: "150px"
                                                        },
                                                        children: "ใบตรวจเช็ตสต๊อก"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Button, {
                                                        type: "submit",
                                                        className: "btn-st-3 ",
                                                        onClick: function() {},
                                                        children: "เลือก"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(ListGroup.Item, {
                                                className: "d-flex align-items-center justify-content-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-16",
                                                        style: {
                                                            width: "150px"
                                                        },
                                                        children: "ใบปรับปรุงสต๊อก"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Button, {
                                                        type: "submit",
                                                        className: "btn-st-3 ",
                                                        onClick: function() {},
                                                        children: "เลือก"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(ListGroup.Item, {
                                                className: "d-flex align-items-center justify-content-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-16",
                                                        style: {
                                                            width: "150px"
                                                        },
                                                        children: "ใบตัดสต๊อก"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Button, {
                                                        type: "submit",
                                                        className: "btn-st-3 ",
                                                        onClick: function() {},
                                                        children: "เลือก"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
